export const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const snakeCaseToTitle = (text) => {
    return (text.charAt(0).toUpperCase() + text.slice(1)).replace(/_/g, ' ');
};
